import $api from "@/frontend/shared/api/axios";
import { ConditionRowFilterExtended } from "@/frontend/components/FilterV2/model/types";

export async function postGetFilteredStage(
  {
    stageId,
    filters,
    limit = 100,
    page = 1
  }: {
    stageId: number;
    filters: ConditionRowFilterExtended[];
    limit?: number;
    page?: number;
    includeCompanies?: boolean;
  },
  options: any = {}
) {
  const requestBody = {
    page,
    limit,
    filters
  };

  const res = await $api.post(`/stages/v2/${stageId}`, requestBody, options);

  return res.data.data;
}
